import { render, staticRenderFns } from "./crewFood.vue?vue&type=template&id=76dd6457"
import script from "./crewFood.vue?vue&type=script&lang=js"
export * from "./crewFood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports